/* eslint-disable */
import materialUI from "material-UI";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerSelect = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 51px;
`;

export const SelectText = styled.p`
  font-family: Inter;
  color: #2d5bff;
  font-size: 16px;
`;

interface Props {
  show: any;
}

export const FooterContainer = styled.div<Props>`
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  height: 80px;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #ececec;
  display: ${(props) => (props.show ? "auto" : "none")};
  z-index: 99;
`;

export const Button = styled(materialUI.Button)`
  padding: 24px;
  background-color: #f43636;
  margin-top: 16px;
  color: #ffffff;
  width: 92%;
  height: 48px;
  &:hover {
    background-color: #f55050;
  }
`;
